import React, { useEffect, useState } from 'react';

const Countdown = () => {
  const [timeRemaining, setTimeRemaining] = useState(getTimeRemaining());

  function getTimeRemaining() {
    const now = new Date();
    const targetTime = new Date(now);
    targetTime.setHours(24, 0, 0, 0); // Set the target time to the next 24 hours

    const timeDiff = Number(targetTime) - Number(now);
    const hours = Math.floor((timeDiff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    const minutes = Math.floor((timeDiff % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((timeDiff % (1000 * 60)) / 1000);

    return { hours, minutes, seconds };
  }

  useEffect(() => {
    const interval = setInterval(() => {
      setTimeRemaining(getTimeRemaining());
    }, 1000);

    return () => clearInterval(interval);
  }, []);

  return (
    <div className="flex w-full items-center justify-between gap-2 md:gap-4">
      <div className=" text-center  w-full border-2 border-black bg-warm-orange shadow-lg  text-black rounded-lg p-2 md:p-4">
        <span className='text-3xl md:text-3xl font-bold text-black'>{timeRemaining.hours}</span>
        <p className='uppercase text-black text-sm md:text-lg'>Hours</p>
      </div>
      <div className=" text-center  w-full border-2 border-black bg-warm-orange shadow-lg  text-black rounded-lg p-2 md:p-4">
        <span className='text-3xl md:text-3xl font-bold text-black'>{timeRemaining.minutes}</span>
        <p className='uppercase text-black text-sm md:text-lg'>Mins</p>
      </div>
      <div className=" text-center  w-full border-2 border-black bg-warm-orange shadow-lg  text-black rounded-lg p-2 md:p-4">
        <span className='text-3xl md:text-3xl font-bold text-black'>{timeRemaining.seconds}</span>
        <p className='uppercase text-black text-sm md:text-lg'>Sec</p>
      </div>
    </div>
  );
};

export default Countdown;
